import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { MirrorDatePipeModule } from '../../_pipes/mirror-date.pipe';
import { MqIfDirectiveModule } from '../../_directives/mqif.directive';

import { PdfViewerModule } from 'ng2-pdf-viewer';

import { OrderViewerComponent } from './order-viewer.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatCardModule,
        MatIconModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatSelectModule,
        MatChipsModule,
        MatInputModule,
        MatButtonModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatExpansionModule,
        // FlexLayoutModule,
        MirrorDatePipeModule,
        MqIfDirectiveModule,
        PdfViewerModule,
    ],
    declarations: [
        OrderViewerComponent
    ],
    exports: [
        OrderViewerComponent
    ]
})
export class OrderViewerModule { }